module.exports = __webpack_public_path__ + "static/media/footer-ico6.4cf74cc0.svg";